import { RuntimeStatus } from '@/enums/runtime-status.enum';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'queryStatus',
  standalone: false,
})
export class QueryStatusPipe implements PipeTransform {
  transform(value?: number): string | void {
    if (typeof value === 'undefined' || value < 0) return;
    return RuntimeStatus[value];
  }
}
